var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { listTypeBlocks } from '..';
import { LayoutConst } from '../../../../../core/modules/layout.module';
var GeoItemWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  display: flex;\n  align-items: flex-start;\n  ", "\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    margin-bottom: ", ";\n  }\n"], ["\n  margin-bottom: ", ";\n  display: flex;\n  align-items: flex-start;\n  ", "\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    margin-bottom: ", ";\n  }\n"])), function (props) { return (props.isLast ? '48px' : '44px'); }, function (p) { return (p.isLink ? 'cursor: pointer;' : ''); }, LayoutConst.screen.s, function (props) { return (props.isLast ? '18px' : '16px'); });
var GeoItemImage = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: auto;\n  height: auto;\n  flex-shrink: 0;\n  margin-right: 19px;\n  padding-top: 5px;\n"], ["\n  width: auto;\n  height: auto;\n  flex-shrink: 0;\n  margin-right: 19px;\n  padding-top: 5px;\n"])));
var GeoItemText = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var GeoItemTitle = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 32px;\n  letter-spacing: -0.02em;\n  color: ", ";\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 32px;\n  letter-spacing: -0.02em;\n  color: ", ";\n"])), function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); });
var GeoItemCapital = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: ", ";\n\n  a {\n    font-weight: bold;\n    color: ", ";\n\n    &:hover {\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: ", ";\n\n  a {\n    font-weight: bold;\n    color: ", ";\n\n    &:hover {\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n"])), function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); }, function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); }, function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); });
var GeoItemNum = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 33px;\n  text-align: center;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  color: #151514;\n"], ["\n  width: 33px;\n  text-align: center;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  color: #151514;\n"])));
var GeoImg = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 50px !important;\n  height: 50px !important;\n"], ["\n  width: 50px !important;\n  height: 50px !important;\n"])));
var LEAGUES_NAMES = [
    'bee',
    'knight',
    'inyan',
    'unicorn',
    'swan',
    'stargazer',
    'bear',
    'lion',
    'eagle',
    'munchausen',
    'einstein',
    'sun',
    'elephant',
    'heracles',
    'dragon'
];
var ORDERS_NAMES = [
    'zero',
    'lily',
    'keys',
    'swords',
    'windmill',
    'towers',
    'continents',
    'rubyStar',
    'phoenix',
    'arcane'
];
var CLIMAT_BELTS = [
    'furiousfifties',
    'roaringforties',
    'southsubtropical',
    'southtropical',
    'southsubeq',
    'equatorial',
    'northsubeq',
    'northtropical',
    'northsubtropical',
    'wildwest',
    'greateast',
    'northumbria',
    'north',
    'arctic'
];
var MAGISTRATES_NAMES = ['northeast', 'southeast', 'northwest', 'southwest'];
var getLegauName = function (itemProps) {
    var leaguePropIdString = itemProps && itemProps.image && itemProps.image.imageId;
    var leaguePropId = leaguePropIdString.length
        ? leaguePropIdString.split('-')[1]
        : '';
    var leagueId = leaguePropId && !isNaN(leaguePropId) ? +leaguePropId - 1 : 0;
    return LEAGUES_NAMES[leagueId];
};
var getOrderName = function (itemProps) {
    var orderId = itemProps.geoItemId - 1;
    return ORDERS_NAMES[orderId];
};
var getBeltName = function (itemProps) {
    var beltId = itemProps.geoItemId;
    return CLIMAT_BELTS[beltId] || '';
};
var getMagistratureName = function (itemProps) {
    var magistratureString = itemProps && itemProps.geoItemId;
    var magistratureId = !isNaN(magistratureString)
        ? +magistratureString - 1
        : 0;
    return MAGISTRATES_NAMES[magistratureId];
};
var clickHandler = function (props) {
    var type = props.type, specBlockProps = props.specBlockProps, itemProps = props.itemProps;
    var history = (specBlockProps || {}).history;
    var url;
    if (['leaguelist'].includes(type)) {
        var leagueName = getLegauName(itemProps);
        url = "/ratings/league/".concat(leagueName);
    }
    if (['magistrature'].includes(type)) {
        var magistratureName = getMagistratureName(itemProps);
        url = "/ratings/magistrate/".concat(magistratureName);
    }
    if (['orderlist'].includes(type)) {
        var orderName = getOrderName(itemProps);
        url = "/ratings/order/".concat(orderName);
    }
    if (['geozone'].includes(type)) {
        var beltName = getBeltName(itemProps);
        url = "/ratings/climatbelt/".concat(beltName);
    }
    if (typeof history === 'object') {
        history.push(url);
        return;
    }
    window.location.href = window.location.origin + url;
};
function GeoItem(props) {
    var _a, _b;
    var image = props.image, title = props.title, text = props.text, isLast = props.isLast, num = props.num, type = props.type, itemProps = props.itemProps, specBlockProps = props.specBlockProps, hasButton = props.hasButton, theme = props.theme;
    var isLink = listTypeBlocks.includes(type);
    var onLinkClick = useCallback(function () {
        if (!isLink) {
            return;
        }
        clickHandler({ type: type, specBlockProps: specBlockProps, itemProps: itemProps });
    }, [isLink, type, specBlockProps, itemProps]);
    var isOrder = type === 'orderlist';
    return (React.createElement(GeoItemWrap, { isLast: isLast, isLink: isLink, onClick: onLinkClick, className: 'spec-geo-item-wrap' },
        React.createElement(GeoItemImage, { className: 'spec-geo-item-image-wrap' },
            React.createElement(GeoImg, { src: image, alt: 'coa', isOrder: isOrder })),
        React.createElement(GeoItemText, { className: 'spec-geo-item-text-wrap' },
            React.createElement(GeoItemTitle, { textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.geoItem) === null || _a === void 0 ? void 0 : _a.textColor, hasButton: hasButton }, title),
            !text || text === '' ? ('') : (React.createElement(GeoItemCapital, { textColor: (_b = theme === null || theme === void 0 ? void 0 : theme.geoItem) === null || _b === void 0 ? void 0 : _b.textColor, hasButton: hasButton, dangerouslySetInnerHTML: { __html: text } })))));
}
export default GeoItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=geoitem.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { listTypeBlocks } from '..';
import { LayoutConst } from '../../../../../core/modules/layout.module';
var GeoItemWrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n  display: flex;\n  align-items: flex-start;\n  ", "\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    margin-bottom: ", ";\n  }\n"], ["\n  margin-bottom: ", ";\n  display: flex;\n  align-items: flex-start;\n  ", "\n  @media (max-width: ", "px) {\n    padding-left: 16px;\n    margin-bottom: ", ";\n  }\n"])), function (props) { return (props.isLast ? '48px' : '44px'); }, function (p) { return (p.isLink ? 'cursor: pointer;' : ''); }, LayoutConst.screen.s, function (props) { return (props.isLast ? '18px' : '16px'); });
var GeoItemImage = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: auto;\n  height: auto;\n  flex-shrink: 0;\n  margin-right: 19px;\n  padding-top: 5px;\n"], ["\n  width: auto;\n  height: auto;\n  flex-shrink: 0;\n  margin-right: 19px;\n  padding-top: 5px;\n"])));
var GeoItemText = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var GeoItemTitle = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 32px;\n  letter-spacing: -0.02em;\n  color: ", ";\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 32px;\n  letter-spacing: -0.02em;\n  color: ", ";\n"])), function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); });
var GeoItemCapital = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: ", ";\n\n  a {\n    font-weight: bold;\n    color: ", ";\n\n    &:hover {\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n"], ["\n  font-family: Inter;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  color: ", ";\n\n  a {\n    font-weight: bold;\n    color: ", ";\n\n    &:hover {\n      text-decoration: none;\n      color: ", ";\n    }\n  }\n"])), function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); }, function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); }, function (p) { return p.textColor || (p.hasButton ? '#FEFEFE' : '#151514'); });
var GeoItemNum = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 33px;\n  text-align: center;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  color: #151514;\n"], ["\n  width: 33px;\n  text-align: center;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  color: #151514;\n"])));
var GeoImg = styled.img(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 50px !important;\n  height: 50px !important;\n"], ["\n  width: 50px !important;\n  height: 50px !important;\n"])));
var LEAGUES_NAMES = [
    'bee',
    'knight',
    'inyan',
    'unicorn',
    'swan',
    'stargazer',
    'bear',
    'lion',
    'eagle',
    'munchausen',
    'einstein',
    'sun',
    'elephant',
    'heracles',
    'dragon'
];
var ORDERS_NAMES = [
    'zero',
    'lily',
    'keys',
    'swords',
    'windmill',
    'towers',
    'continents',
    'rubyStar',
    'phoenix',
    'arcane'
];
var CLIMAT_BELTS = [
    'furiousfifties',
    'roaringforties',
    'southsubtropical',
    'southtropical',
    'southsubeq',
    'equatorial',
    'northsubeq',
    'northtropical',
    'northsubtropical',
    'wildwest',
    'greateast',
    'northumbria',
    'north',
    'arctic'
];
var MAGISTRATES_NAMES = ['northeast', 'southeast', 'northwest', 'southwest'];
var getLegauName = function (itemProps) {
    var leaguePropIdString = itemProps && itemProps.image && itemProps.image.imageId;
    var leaguePropId = leaguePropIdString.length
        ? leaguePropIdString.split('-')[1]
        : '';
    var leagueId = leaguePropId && !isNaN(leaguePropId) ? +leaguePropId - 1 : 0;
    return LEAGUES_NAMES[leagueId];
};
var getOrderName = function (itemProps) {
    var orderId = itemProps.geoItemId - 1;
    return ORDERS_NAMES[orderId];
};
var getBeltName = function (itemProps) {
    var beltId = itemProps.geoItemId;
    return CLIMAT_BELTS[beltId] || '';
};
var getMagistratureName = function (itemProps) {
    var magistratureString = itemProps && itemProps.geoItemId;
    var magistratureId = !isNaN(magistratureString)
        ? +magistratureString - 1
        : 0;
    return MAGISTRATES_NAMES[magistratureId];
};
var clickHandler = function (props) {
    var type = props.type, specBlockProps = props.specBlockProps, itemProps = props.itemProps;
    var history = (specBlockProps || {}).history;
    var url;
    if (['leaguelist'].includes(type)) {
        var leagueName = getLegauName(itemProps);
        url = "/ratings/league/".concat(leagueName);
    }
    if (['magistrature'].includes(type)) {
        var magistratureName = getMagistratureName(itemProps);
        url = "/ratings/magistrate/".concat(magistratureName);
    }
    if (['orderlist'].includes(type)) {
        var orderName = getOrderName(itemProps);
        url = "/ratings/order/".concat(orderName);
    }
    if (['geozone'].includes(type)) {
        var beltName = getBeltName(itemProps);
        url = "/ratings/climatbelt/".concat(beltName);
    }
    if (typeof history === 'object') {
        history.push(url);
        return;
    }
    window.location.href = window.location.origin + url;
};
function GeoItem(props) {
    var _a, _b;
    var image = props.image, title = props.title, text = props.text, isLast = props.isLast, num = props.num, type = props.type, itemProps = props.itemProps, specBlockProps = props.specBlockProps, hasButton = props.hasButton, theme = props.theme;
    var isLink = listTypeBlocks.includes(type);
    var onLinkClick = useCallback(function () {
        if (!isLink) {
            return;
        }
        clickHandler({ type: type, specBlockProps: specBlockProps, itemProps: itemProps });
    }, [isLink, type, specBlockProps, itemProps]);
    var isOrder = type === 'orderlist';
    return (React.createElement(GeoItemWrap, { isLast: isLast, isLink: isLink, onClick: onLinkClick, className: 'spec-geo-item-wrap' },
        React.createElement(GeoItemImage, { className: 'spec-geo-item-image-wrap' },
            React.createElement(GeoImg, { src: image, alt: 'coa', isOrder: isOrder })),
        React.createElement(GeoItemText, { className: 'spec-geo-item-text-wrap' },
            React.createElement(GeoItemTitle, { textColor: (_a = theme === null || theme === void 0 ? void 0 : theme.geoItem) === null || _a === void 0 ? void 0 : _a.textColor, hasButton: hasButton }, title),
            !text || text === '' ? ('') : (React.createElement(GeoItemCapital, { textColor: (_b = theme === null || theme === void 0 ? void 0 : theme.geoItem) === null || _b === void 0 ? void 0 : _b.textColor, hasButton: hasButton, dangerouslySetInnerHTML: { __html: text } })))));
}
export default GeoItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=geoitem.js.map